import { render } from "./ListGeneral.vue?vue&type=template&id=62c0d36b"
import script from "./ListGeneral.vue?vue&type=script&lang=js"
export * from "./ListGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__